import useCrud from 'hooks/useCrud';
import { isTiKTokUpperCase } from 'lib/utils/isTikTok';
import { useCallback } from 'react';
import {
  lazadaLogisticsList,
  logisticsList,
  tradeList,
  TradeListParams,
} from 'services/api/conversation';

export const emptyTradeError = 'Can not find the trade from trade list api';

function useTrade(platform: General.PlatformUpperCase, storeId: string | number) {
  return useCrud({
    read: useCallback(
      (params: TradeListParams): Promise<Conversation.Trade.TradeWithLogistics> => {
        return tradeList(params).then((res) => {
          const { tradeList: [trade] = [] } = res;

          if (!trade) {
            return Promise.reject(new Error(emptyTradeError));
          }

          const { internalTradeId } = trade;

          if (platform === 'LAZADA') {
            return lazadaLogisticsList({
              internal_trade_ids: internalTradeId,
            }).then((res) => {
              const {
                data: { data: logisticsList, thirdTrackingInfo: thirdLogisticsList },
              } = res;
              return {
                ...trade,
                lazadaLogistics: logisticsList[0],
                thirdLogisticsList,
              };
            });
          }

          const params = isTiKTokUpperCase(platform)
            ? {
                internalStoreId: storeId,
                internal_trade_ids: internalTradeId,
                needPackageData: true,
              }
            : {
                internal_trade_ids: internalTradeId,
                needReverse: platform === 'SHOPEE' || platform === 'MERCADO',
              };

          return logisticsList(params).then((res) => {
            const {
              data: { data: logisticsList, thirdTrackingInfo: thirdLogisticsList, reverseData },
            } = res;

            return {
              ...trade,
              logisticsList,
              thirdLogisticsList,
              reverseLogisticsList: reverseData,
            };
          });
        });
      },
      [platform, storeId],
    ),
  });
}

export default useTrade;
